<dm-navigation *ngIf="!this.stateService.params.hideNavigationBar"></dm-navigation>
<!-- The ui-view tag will be populated with whichever state is currently selected under the Entry parent state -->
<ui-view></ui-view>
<dm-notification-bar></dm-notification-bar>